import { Component } from "@angular/core";
import { NavController, NavParams, LoadingController } from "ionic-angular";
import { Http } from "@angular/http";
import { ModalController } from "ionic-angular";
import { AlertController } from "ionic-angular";

import config from "../../config/config";

@Component({
  selector: "page-home",
  templateUrl: "home.html"
})
export class HomePage {
  form = {
    nome: "",
    arquivo: "",
    curso: "",
    finalizado: "",
    nomeEmpresa: "",
    destino: "",
    empressa: "",
    cargo: "",
    email: "",
    ano: "",
    mensagem: "",
    facebook: "",
    linkdin: "",
    termo: false
  };
  ano = null;
  checked = null; 
  formacao = [
    { val: "Graduação", isChecked: false, curso:"", ano:"" }, 
    { val: "Mestrado", isChecked: false, curso:"", ano:""  },
    { val: "Doutorado", isChecked: false, curso:"", ano:"" }
  ];
  empresas = [
    { val: "Empresa", isChecked: false },
    { val: "Instituição", isChecked: false }
  ];
  tipo = null;
  file = null;
  foto = "thumb/RZ6gvd0lz0uhP5pvB5upgVz7wYyjhN3oWwGP71Wp.png";
  foto2 = "thumb/RZ6gvd0lz0uhP5pvB5upgVz7wYyjhN3oWwGP71Wp.png";

  alert = null;
  disabled = true;
  liberarDoutorado: number;
  liberarMestrado: number;
  liberarGraduacao: number;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public _http: Http,
    private alertCtrl: AlertController,
    public modalCtrl: ModalController
  ) {}

  ngOnInit() {
    // console.log(this.foto);
    console.log(this.empresas);
    this.pegarCategorias();
  }
  enviadoSucesso() {
    this.alert = this.alertCtrl.create({
      title: "Enviado !!",
      message:
        "Sua mensagem foi enviada e será analisada por um administrador.",
      buttons: [
        {
          text: "Ok",
          handler: data => {
            window.location.href = "http://www.im.ufrj.br";
          }
        }
      ]
    });
    this.alert.present();
  }
  falhaPreenchimento() {
    this.alert = this.alertCtrl.create({
      title: "Erro de preenchimento",
      message: "Por favor preencha os campos obrigatórios(*).",
      buttons: [
        {
          text: "Ok",
          handler: data => {
            window.location.href = "#";
          }
        }
      ]
    });
    this.alert.present();
  }
  cadastrar(form) {
    if (form.arquivo) {
      form.arquivo = this.foto;
    }
    form.checked = this.checked;
    form.empresa = this.tipo;
    // for (let k = 0; k < this.ano.length; k++) {
    //   var conf = this.ano[k];
    //   if (form.ano == conf.id) {
    //     form.categoriatitulo = conf.title;
    //   }
    // }
    // console.log(form);
    // console.log(this.formacao);
    let forma = "";
    let anoConclusão = 0;

    if (this.formacao[0].isChecked && this.formacao[0].curso) {
      forma = forma+"<p><strong>"+this.formacao[0].val+":</strong> "+this.formacao[0].curso+"<br><strong>Ano de Conclusão:</strong> "+this.formacao[0].ano+"</p>";
      anoConclusão = Number(this.formacao[0].ano);
    }
    if (this.formacao[1].isChecked && this.formacao[1].curso) {
      forma = forma+"<p><strong>"+this.formacao[1].val+":</strong> "+this.formacao[1].curso+"<br><strong>Ano de Conclusão:</strong> "+this.formacao[1].ano+"</p>";
      anoConclusão = Number(this.formacao[1].ano);

    }
    if (this.formacao[2].isChecked && this.formacao[2].curso) {
      forma = forma+"<p><strong>"+this.formacao[2].val+":</strong> "+this.formacao[2].curso+"<br> <strong>Ano de Conclusão:</strong> "+this.formacao[2].ano+"</p>";
      anoConclusão = Number(this.formacao[2].ano);

    }
    form.curso = forma;
    // console.log(anoConclusão);
    // console.log(this.ano);
    for (let k = 0; k < this.ano.length; k++) {
      var tituloCategoria = this.ano[k].title;
      let quebrando = tituloCategoria.split("-")
      let menor = quebrando[0];
      let maior = quebrando[1];
      if (!quebrando[1]) {
        maior = menor;
      }

      if (anoConclusão >= menor && anoConclusão <= maior) {
        form.ano = this.ano[k].id;
        form.categoriatitulo = tituloCategoria;
      //   console.log(menor);
      // console.log(maior);
      }
      
    }

    const checagemGeral = this.checarObrigatorios(form);

    if (checagemGeral) {
      // console.log(form);
      let loading = this.loadingCtrl.create({
        content: "Enviando."
      });
      loading.present();
      this._http
        .post(config.urlAPI + "formulario/cadastrar", form, {})
        .map(res => res.json())
        .toPromise()
        .then(res => {
          console.log(res);
          loading.dismiss();
          this.enviadoSucesso();
        })
        .catch(error => {
          console.log(error);
        });
    } else {
      this.falhaPreenchimento();
    }
  }
  arquivo(event) {
    this.file = <File>event.target.files[0];
    console.log(this.file);
    this.subirImage();
  }
  subirImage() {
    let imagem = this.file;
    const fd = new FormData();
    fd.append("image", imagem, imagem.name);
    this._http
      .post(config.urlAPI + "formulario/comprovante", fd, {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        this.foto = res;
        // console.log(res);
      })
      .catch(error => {
        console.log(error);
      });
  }
  empresatestar(form) {
    if (form.val == "Empresa") {
      this.empresas = [
        { val: "Empresa", isChecked: true },
        { val: "Instituição", isChecked: false }
      ];
    } else {
      this.empresas = [
        { val: "Empresa", isChecked: false },
        { val: "Instituição", isChecked: true }
      ];
    }
    this.tipo = form.val;
  }
  teste(env) {
    if (env.val == "Graduação") {
      if (this.liberarGraduacao == 1) {
        this.liberarGraduacao = 0;
      }else{
        this.liberarGraduacao = 1;
      }
    } else if (env.val == "Mestrado") {
      if (this.liberarMestrado == 1) {
        this.liberarMestrado = 0;
      }else{ 
        this.liberarMestrado = 1;
      }
    } else {
      if (this.liberarDoutorado == 1) {
        this.liberarDoutorado = 0;    
      }else{
        this.liberarDoutorado = 1;
      }
    }
    // console.log(env);
    this.checked = env.val;

  }
  pegarCategorias() {
    this._http
      .get(config.urlSite + "Categoria/Pesquisar", {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        this.ano = res;
      })
      .catch(error => {
        console.log(error);
      });
  }

  checarObrigatorios(form) {
    
    if (
      !form.curso ||
      !form.empresa ||
      !form.email ||
      !form.ano ||
      !form.checked ||
      !form.categoriatitulo ||
      !form.nome
    ) {
      return false;
    } else {
      return true;
    }
  }
  checarTermo() {
    if (this.form.termo) {
      this.disabled = false;
    } else {
      this.disabled = true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts